export const checkinList = {
  group: {
    sectionTitle: "Check-ins asociados",
    registrationForm: "Planilla de registro",
    registrationFormHint: "Un solo documento con el titular y sus acompañantes",
    registrationFormEmpty: "Todavía no hay ningún check-in hecho en esta reserva.",
    registrationFormError: "No se pudo generar la planilla. Inténtalo de nuevo.",
    emptyState: "No hay check-ins asociados.",
    name: "Nombre",
    phone: "Teléfono",
    document: "Documento",
    notAvailable: "No disponible",
    syncSent: "Enviado a migración",
    syncError: "Error en migración",
    syncPending: "Pendiente de envío",
    moreInfo: "Más información",
    email: "Email",
    checkIn: "Entrada",
    checkOut: "Salida",
    docType: "Tipo de documento",
    supportNumber: "Número de soporte",
    documentBack: "Reverso",
    identityNoMatch: "Las caras no coinciden",
    identityStored: "Sin comparación facial",
    identityError: "No se pudo comparar",
    identityNoPhotos: "En este país no se guardan las fotos: solo queda el resultado.",
    identityVerification: "Verificación de identidad",
    tapToEnlarge: "Toca para ampliar",
    view: "Ver",
    download: "Descargar",
    selfie: "Selfie",
    minorData: "Datos de menor de edad",
    relationship: "Parentesco:",
    noPhotos: "No hay fotos adjuntas.",
    minorDocument: "Documento del menor",
    authorization: "Autorización",
    minorAuthorization: "Autorización del menor",
    specification: "Especificación:",
    additionalInfo: "Información adicional",
    nationality: "Nacionalidad",
    birthDate: "Fecha de nacimiento",
    ageYears: "({age} años)",
    gender: "Género",
    female: "Femenino",
    male: "Masculino",
    countryResidence: "País de residencia",
    cityResidence: "Ciudad de residencia",
    address: "Dirección",
    zipCode: "Código postal",
    sesBatchId: "ID Lote SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "País de nacimiento",
    docIssuePlace: "Lugar expedición doc.",
    signedDocument: "Documento firmado",
    edit: "Editar",
    remove: "Eliminar",
    previewAlt: "Vista previa",
    previewFallbackTitle: "Imagen",
    docTypes: {
      passport: "Pasaporte",
      passportOrdinary: "Pasaporte ordinario",
      passportService: "Pasaporte de servicio",
      passportDiplomatic: "Pasaporte diplomático",
      idCard: "Documento de identidad",
      nie: "NIE",
      idCardElectronic: "Documento de identidad electrónico",
      idDiplomatic: "Documento ID diplomático",
      citizenshipCard: "Cédula de ciudadanía",
      foreignerCard: "Cédula de extranjería",
      drivingLicense: "Permiso de conducir",
      nauticalLicense: "Permiso náutico",
      specialResidencePermit: "Permiso especial de permanencia",
      foreignerDocument: "Documento de extranjero",
      foreignDocument: "Documento extranjero",
      diplomaticCard: "Carné diplomático",
      refugeeTravelDocument: "Título viaje refugiado",
      otherDocument: "Otro documento",
    },
  },
  individual: {
    title: "Datos del huésped",
    phone: "Teléfono",
    email: "Email",
    notAvailable: "No disponible",
    lodging: "Hospedaje",
    docType: "Tipo de documento",
    docNumber: "Número de documento",
    supportNumber: "Número de soporte",
    identityVerification: "Verificación de identidad",
    document: "Documento",
    tapToEnlarge: "Toca para ampliar",
    view: "Ver",
    download: "Descargar",
    selfie: "Selfie",
    minorData: "Datos de menor de edad",
    relationship: "Parentesco:",
    noPhotos: "No hay fotos adjuntas.",
    minorDocument: "Documento del menor",
    authorization: "Autorización",
    minorAuthorization: "Autorización del menor",
    specification: "Especificación:",
    additionalInfo: "Información adicional",
    nationality: "Nacionalidad",
    birthDate: "Fecha de nacimiento",
    ageYears: "({age} años)",
    gender: "Género",
    female: "Femenino",
    male: "Masculino",
    countryResidence: "País de residencia",
    cityResidence: "Ciudad de residencia",
    address: "Dirección",
    zipCode: "Código postal",
    sesBatchId: "ID Lote SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "País de nacimiento",
    docIssuePlace: "Lugar expedición doc.",
    signedDocument: "Documento firmado",
    edit: "Editar",
    previewAlt: "Vista previa",
    previewFallbackTitle: "Imagen",
    docTypes: {
      passport: "Pasaporte",
      passportOrdinary: "Pasaporte ordinario",
      passportService: "Pasaporte de servicio",
      passportDiplomatic: "Pasaporte diplomático",
      idCard: "Documento de identidad",
      nie: "NIE",
      idCardElectronic: "Documento de identidad electrónico",
      idDiplomatic: "Documento ID diplomático",
      citizenshipCard: "Cédula de ciudadanía",
      foreignerCard: "Cédula de extranjería",
      drivingLicense: "Permiso de conducir",
      nauticalLicense: "Permiso náutico",
      specialResidencePermit: "Permiso especial de permanencia",
      foreignerDocument: "Documento de extranjero",
      foreignDocument: "Documento extranjero",
      diplomaticCard: "Carné diplomático",
      refugeeTravelDocument: "Título viaje refugiado",
      otherDocument: "Otro documento",
    },
  },
};
